import { createStore } from 'vuex'
import commonModules from './commonModule'
import userModule from './userModule'
import businessUserModule from './businessUserModule'
import deviceModule from './deviceModule'
import { menu } from '../utils/menuData'

const session=window.sessionStorage

// 模块文件配置
const userType = import.meta.env.VITE_APP_USERTYPE || 'business'

export default createStore({
  state: {
    user: { isLogin: false, account: '···', loginType: userType },
    https: {},
    token: localStorage.getItem('authToken-hsd-web-' + userType) || '',
    error: { status: false },
    cachePages: [],
    isRefresh: false,
    routerList: JSON.parse(session.getItem('router-quick')) || [],
    menuLeft: menu,
    // 多页面跳转储存数据 针对路由跳转({name,params})
    routerParams: {}
  },
  mutations: {
    // 去往登录页
    toLogin(){
      window.location.href='/'
      // router.push({path:'/login'})
    },
    // 设置页面携带数据
    setRouterParams(state, { name, params }) {
      state.routerParams[name] = {}
      state.routerParams[name] = params
      
      // 放入全局缓存
      const stringParams=JSON.stringify(state.routerParams)
      window.localStorage.setItem(userType + '-routerParams', stringParams)
    },
    // 修改https值
    setHttps(state, https) {
      state.https = { ...https }
    },
    // 设置用户信息
    setUser(state, user) {
      state.user = { ...state.user, ...user }
    },
    // 更新token
    setToken(state, token) {
      state.token = token
      localStorage.setItem('authToken-hsd-web-' + userType, token)
    },
    setLoginOut(state) {
      state.token = ''
      state.user = { isLogin: false }
      localStorage.removeItem('authToken-hsd-web-' + userType)
      state.routerList = []
      localStorage.removeItem('router-quick')
    },
    // 设置error
    setError(state, params) {
      state.error = { ...params }
    },
    // 设置是否刷新
    setIsRefresh(state, value) {
      state.isRefresh = value
    },
    // 设置缓存组件列表
    setCachePages(state, data) {
      state.cachePages = data
      // let bool = state.cachePage.includes(name);
      // if (!bool) state.cachePage.push(name);

      // let bool = state.cachePage.includes(name);
      // if (bool) state.cachePage.splice(state.cachePage.indexOf(name), 1);
    },
    // 设置快捷路由列表
    setRouterListAll(state, params) {
      state.routerList = params
      // window.sessionStorage.setItem('router-quick', JSON.stringify(state.routerList))
    },
    setRouterList(state, params) {
      if (params.data && params.data.name) {
        if (!params.isRemove) {
          if (!state.routerList.some(item => item.name === params.data.name)) {
            state.routerList.push(params.data)
          }
        } else {
          state.routerList.map((item, index) => {
            if (item.name === params.data.name) {
              state.routerList.splice(index, 1)
            }
          })
        }
      }
      // window.sessionStorage.setItem('router-quick', JSON.stringify(state.routerList))
    },
    // 左侧菜单
    setMenuLeft(state, data) {
      state.menuLeft = data
    }
  },
  getters: {
    getRouterParams:state=>{
      const s_prams=state.routerParams
      // 全局缓存
      const WL_params=JSON.parse(window.localStorage.getItem(userType + '-routerParams') || '{}')

      return Object.keys(s_prams).length?s_prams:WL_params
    },
    getHttps: state => state.https,
    getToken: state => state.token,
    getLogin: state => state.user.isLogin,
    getUser: state => state.user,
    getError: state => state.error,
    getCachePages: state => state.cachePages,
    getIsRefresh: state => state.isRefresh,
    getRouterList: state => state.routerList,
    getMenuList: state => state.menuLeft,
    // isBusinessDepartment
    isBusinessDepartment: state => state.user.companyCode === 'business_department'
  },
  actions: {},
  modules: {
    commonModules,
    userModule,
    businessUserModule,
    deviceModule
  }
})
